import { useEffect, useRef, useState } from "react";
import Hls from "hls.js";

export function HlsPlayer({ src, snapshot, testid = "hls-preview" }) {
  const ref = useRef(null);
  const [info, setInfo] = useState({ state: "loading", level: null, err: null });
  const [tick, setTick] = useState(0);
  const noCodec = typeof MediaSource !== "undefined" && !MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E"');
  useEffect(() => { const t = setInterval(() => setTick((x) => x + 1), 2000); return () => clearInterval(t); }, []);

  useEffect(() => {
    const v = ref.current;
    if (!v || !src || noCodec) return;
    let hls;
    if (Hls.isSupported()) {
      hls = new Hls({ liveSyncDurationCount: 3, xhrSetup: (x) => { x.withCredentials = true; } });
      hls.loadSource(src);
      hls.attachMedia(v);
      hls.on(Hls.Events.MANIFEST_PARSED, () => { v.muted = true; v.play().catch(() => {}); setInfo((i) => ({ ...i, state: "playing", err: null })); });
      hls.on(Hls.Events.LEVEL_LOADED, (_, d) => setInfo((i) => ({ ...i, level: d.details })));
      hls.on(Hls.Events.ERROR, (_, d) => {
        if (d.fatal) {
          setInfo((i) => ({ ...i, state: "error", err: d.details }));
          setTimeout(() => { try { hls.loadSource(src); hls.startLoad(); } catch (e) { /* noop */ } }, 3000);
        }
      });
    } else {
      v.src = src;
    }
    return () => hls && hls.destroy();
  }, [src, noCodec]);

  const d = info.level;
  if (noCodec && snapshot) {
    return (
      <div className="space-y-2">
        <div className="relative aspect-video bg-black rounded border border-slate-800 overflow-hidden">
          <img data-testid="output-snapshot" src={`${snapshot}?t=${tick}`} alt="output snapshot" className="w-full h-full object-contain" onError={(e) => { e.currentTarget.style.opacity = 0.2; }} />
        </div>
        <p className="text-[11px] font-mono text-amber-400">This browser cannot decode H.264 — showing live output snapshots (every 2 s).</p>
      </div>
    );
  }
  return (
    <div className="space-y-2">
      <div className="relative aspect-video bg-black rounded border border-slate-800 overflow-hidden">
        <video data-testid={testid} ref={ref} controls muted playsInline className="w-full h-full object-contain" />
        {info.state === "error" && (
          <div className="absolute inset-0 grid place-items-center bg-black/70 text-xs font-mono text-red-400">
            preview error: {info.err} — retrying
          </div>
        )}
      </div>
      <div className="flex gap-4 text-[11px] font-mono text-slate-500">
        <span>player: <span className="text-slate-300">{info.state}</span></span>
        {d && <span>seq <span className="text-slate-300">{d.startSN}</span>→<span className="text-slate-300">{d.endSN}</span></span>}
        {d && <span>target <span className="text-slate-300">{d.targetduration}s</span></span>}
      </div>
    </div>
  );
}
